import React from "react";

import { useQuery } from "@apollo/client";

// @ts-ignore
import { loader, gql } from "graphql.macro";

import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from "@material-ui/core/styles";

import FormControl from "@material-ui/core/FormControl";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import PanelSelect from "./panel-select-mui";
import { NodeClasses } from "./NodeClasses";

import { panelSelectVar } from "./apollo-client";

// import * as Moment from "moment";
// import { extendMoment } from "moment-range";

// const moment = extendMoment(Moment);

const GetAllNodes = loader("./graphql/GetAllNodes.graphql");

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      // margin: theme.spacing(0),
      // paddingLeft: theme.spacing(1),
      // paddingRight: theme.spacing(1),
    },
    formControl: {
      minWidth: "150px",
      margin: theme.spacing(0, 1),
    },
  })
);

const PANEL_QUERY = gql`
  {
    panelSelect @client {
      panelId
    }
  }
`;

interface Props {}

// TODO cf. DurationSelect (hal-playground)

function GlobalPanelPicker(props: Props) {
  const classes = useStyles(props);
  const theme = useTheme() as Theme;
  const fullWidth = useMediaQuery(theme.breakpoints.down("xs"));
  // const context = useContext(IntervalSelectContext);

  // const [selectedDate, setSelectedDate] = React.useState<Date | null>(new Date()/*"-"*/);
  // const [value, setValue] = useState("1day");

  // const { startDate, endDate, duration, durationISO } = data;
  //: { startDate, endDate, duration, durationISO }

  // TODO suspend true when react bug fixed
  const {
    data: allNodesData,
    error: allNodesError,
    loading: allNodesLoading,
  } = useQuery(GetAllNodes, {});
  const { data, error, loading } = useQuery(PANEL_QUERY);

  if (allNodesLoading) {
    return <div>Loading...</div>;
  }
  if (allNodesError) {
    console.error(allNodesError);
    return <p>Error :(</p>;
  }

  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error);
    return <p>Error :(</p>;
  }

  const name = "global-panel-picker";
  const label = "Data Source";

  function handlePanelChange(event: any) {
    // event.preventDefault();
    // event.stopPropagation();
    // const panelId = event.target.value;
    const panelId = event;
    panelSelectVar({
      ...data.panelSelect,
      __typename: "PanelSelect",
      panelId,
    });
    if (localStorage) {
      localStorage.setItem("lastPanelId", panelId);
    }
  }

  const value = data.panelSelect.panelId;

  // TODO all
  // TODO custom
  return (
    <FormControl fullWidth={fullWidth} className={classes.formControl}>
      <PanelSelect
        name={name}
        label={label}
        onChange={handlePanelChange}
        // inputProps={restInput}
        value={value}
        nodes={allNodesData.nodes}
        nodeClasses={[NodeClasses.PANEL]}
      />
    </FormControl>
  );
}

export default GlobalPanelPicker;
